import { render, staticRenderFns } from "./AffirmUpdater.vue?vue&type=template&id=8e1c62b0"
import script from "./AffirmUpdater.vue?vue&type=script&lang=js"
export * from "./AffirmUpdater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports